import { ViewRecipe } from "./ViewRecipe";
import { ViewDetails } from "./ViewDetails/ViewDetails";
import RecipeHeader from "./RecipeHeader";
import { ChipBar } from "./ChipBar/ChipBar";
export { ViewDetails, ChipBar, RecipeHeader };
export default ViewRecipe;
